module.exports = __webpack_public_path__ + "img/imagen2.df921234.png";